module.exports = __webpack_public_path__ + "static/jeff-dean-48df73a523a543c1e3ab78a889e2f8fe.jpg";